import { lazy } from "react";
import Loadable from "../../components/Loadable";
import { PENDING_LEAVE_REQUEST } from "../../utils/constant";
// import {LEAVE_POLICY, PENDING_LEAVE_REQUEST} from "../../utils/constant";

const MarkAttendance = Loadable(lazy(() => import("./MarkAttendance")));
const StaffAttendance = Loadable(lazy(() => import("./StaffAttendance")));
const attendanceRoute = [
  {
    path: '/attendance/mark',
    element: <MarkAttendance />
  },
  {
    path :"/attendance/staff-attendance",
    element : <StaffAttendance/>,
    permission: PENDING_LEAVE_REQUEST,
  },
//   {
//     path :"/leave/pendingRequest",
//     element : <PendingLeaveRequest/>,
//     permission: PENDING_LEAVE_REQUEST,
//   }
];

export default attendanceRoute;